(() => {
  async function handleAddFormSubmit(event) {
    const form = event.target.closest('[data-talent-add-form]');
    if (!form) return;

    event.preventDefault();
    if (form.dataset.talentAdding === 'true') return;

    const button = event.submitter || form.querySelector('[type="submit"]');
    if (!button || button.disabled) return;

    const status = form.querySelector('[data-talent-add-status]');
    const productTitle = form.dataset.productTitle || 'This item';
    const original = button.innerHTML;
    form.dataset.talentAdding = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = `Adding ${productTitle} to your bag.`;

    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${base}cart/add.js`, {
        method: 'POST',
        headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      if (status) status.textContent = `${productTitle} was added to your bag.`;
      if (window.TalentCart) await window.TalentCart.refresh({open: true});
      else window.location.assign(base + 'cart');
    } catch (error) {
      if (status) status.textContent = error.message;
    } finally {
      button.innerHTML = original;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      delete form.dataset.talentAdding;
    }
  }

  document.addEventListener('submit', handleAddFormSubmit, true);

  function init(root = document) {
    root.querySelectorAll('[data-talent-bundle]').forEach(bundle => {
      if (bundle.dataset.ready) return;
      bundle.dataset.ready = 'true';
      const rows = [...bundle.querySelectorAll('[data-bundle-row]')];
      const status = bundle.querySelector('[data-bundle-status]');
      const submit = bundle.querySelector('[data-bundle-submit]');
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:bundle.dataset.currency || 'USD'}).format(value / 100);
      function update() {
        let count = 0, total = 0;
        rows.forEach(row => {
          const qty = Number(row.querySelector('[data-quantity]').textContent);
          count += qty; total += qty * Number(row.dataset.price);
          row.querySelector('[data-decrease]').disabled = qty === 0;
        });
        // Light up the savings tier this selection qualifies for (2, 3, or 4+), and name it in the
        // status line too, since on phones the tier cards are scrolled out of view.
        let deal = '';
        bundle.querySelectorAll('.saving').forEach((tier, i) => {
          const on = count >= 2 && Math.min(count, 4) - 2 === i;
          tier.classList.toggle('is-active', on);
          if (on) deal = ` · ${tier.querySelector('strong').textContent.trim()}`;
        });
        status.textContent = count ? `${count} items selected${deal} · ${money(total)}${count < 2 ? '. Choose at least two.' : ' before eligible discounts.'}` : status.dataset.empty;
        submit.disabled = count < 2;
      }
      bundle.addEventListener('click', e => {
        const control = e.target.closest('[data-increase], [data-decrease]');
        if (!control || control.disabled) return;
        const row = control.closest('[data-bundle-row]'), output = row.querySelector('[data-quantity]');
        output.textContent = Math.max(0, Number(output.textContent) + (control.hasAttribute('data-increase') ? 1 : -1)); update();
      });
      bundle.addEventListener('change', e => {
        if (!e.target.matches('[data-bundle-variant]')) return;
        const row = e.target.closest('[data-bundle-row]'), option = e.target.selectedOptions[0];
        row.dataset.variant = option.value; row.dataset.price = option.dataset.price;
        row.querySelector('.bundle-price').textContent = money(Number(option.dataset.price)); update();
      });
      submit.addEventListener('click', async () => {
        submit.disabled = true;
        try {
          const combined = new Map();
          rows.forEach(row => {
            const quantity = Number(row.querySelector('[data-quantity]').textContent), id = row.dataset.variant;
            if (quantity && id) combined.set(id, (combined.get(id) || 0) + quantity);
          });
          const items = [...combined].map(([id,quantity]) => ({id:Number(id),quantity}));
          const base = window.Shopify?.routes?.root || '/';
          const response = await fetch(base + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add these items. Please try again.');
          status.textContent = 'Added to your bag.';
          if (window.TalentCart) {
            await window.TalentCart.refresh({open: true});
            submit.disabled = false;
          } else {
            window.location.assign(base + 'cart');
          }
        } catch (error) {status.textContent = error.message; submit.disabled = false;}
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
